import { render, staticRenderFns } from "./TeaserCard.vue?vue&type=template&id=3ea48797"
import script from "./TeaserCard.js?vue&type=script&lang=js&external"
export * from "./TeaserCard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports